module.exports = __webpack_public_path__ + "static/media/YM27_0.e71ed7fa.jpg";